export const GET_JURIDICAL_PERSON_ATTEMPT = 'GET_INDEX_JURIDICAL_PERSON_ATTEMPT';
export type GET_JURIDICAL_PERSON_ATTEMPT = typeof GET_JURIDICAL_PERSON_ATTEMPT;

export const GET_JURIDICAL_PERSON_SUCCESS = 'GET_INDEX_JURIDICAL_PERSON_SUCCESS';
export type GET_JURIDICAL_PERSON_SUCCESS = typeof GET_JURIDICAL_PERSON_SUCCESS;

export const GET_JURIDICAL_PERSON_FAILURE = 'GET_INDEX_JURIDICAL_PERSON_FAILURE';
export type GET_JURIDICAL_PERSON_FAILURE = typeof GET_JURIDICAL_PERSON_FAILURE;



// WEBPACK FOOTER //
// ./src/actions/juridical-person/get/Types.tsx